const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_URL;

const BACKEND = {
  BASE_URL: BACKEND_BASE_URL,
};

export default BACKEND;
